import mapActions from './mapActions';

export default mapActions('products', {
    fetchAll_url: data => `/api/orders/${data.order_id}/products`
});